import { graphql } from "../gql";

export const getProviderDashboardSummaryQueryDoc = graphql(`
  query getProviderDashboardSummary {
    providerDashboardSummary {
      claimsAwaitingDocumentIngestion
      claimsAwaitingDocuments
    }
  }
`);
